import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";


const SURVEYPOLLS = () => {
  const [loading, setLoading] = useState(false);
  const [allItemList, setAllItemList] = useState<any[]>([]);

   const {
    data: surveyPolls,
    loading: surveyPollsLoading,
    error: surveyPollsError,
  } = useApi("/api/get-survey-polls", {
    method: "GET",
    autoCall: true,
  });

  useEffect(()=>{
    if(surveyPolls?.success){
      setAllItemList(surveyPolls.data)
    }
  },[surveyPolls])

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "SrNo",
      render: (text: String, record: any, index: any) => (
        <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
      ),
      // sorter: (a: any, b: any) => a.SrNo - b.SrNo,
      sorter: false,
    },
    {
      title: "Survey Title",
      dataIndex: "survey_title",
      sorter: (a: any, b: any) => a.survey_title.localeCompare(b.survey_title),
    },
    {
      title: "Survey Link",
      dataIndex: "survey_link",
      render: (_: any, record: any) => (
        <a href={record.survey_link} target="_blank" rel="noopener noreferrer">
          {record.survey_link}
        </a>
      ),
      sorter: (a: any, b: any) => a.survey_link.localeCompare(b.survey_link),
    },
    {
      title: "Status",
      dataIndex: "featured",
      render: (value: string) => (
        <span
          style={{ color: value === "1" ? "green" : "red", fontWeight: "bold" }}
        >
          {value === "1" ? "Active" : "Inactive"}
        </span>
      ),
      sorter: (a: any, b: any) => a.featured.localeCompare(b.featured),
    },
  ];

  return (
    <>
    <Loader loading={surveyPollsLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Survey/Polls</h2>
              {/* <FaFilePdf /> */}
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Communication & Culture</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Survey/Polls
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Survey/Polls List</h5>
            </div>
            <div className="card-body p-0">
              <Table
                dataSource={allItemList}
                columns={columns}
                Selection={false}
                showSearchInput={true}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">© 2025 WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default SURVEYPOLLS;
